<template>
<!-- 单选 -->
<el-select v-if="selectType === 'select'" ref="select" :disabled="disabled" :clearable="clearable" :class="selectClass" @change="setValue" v-model="selectModel" :placeholder="placeholder" :size="size">
  <el-option v-for="(item, index) in dataList" :key="index" :label="labelType === 'value' ? item : index + ' - ' + item" :value="valueType === 'value' ? index : {'key': index, 'value': item}"></el-option>
</el-select>

<!-- 多选 -->
<div v-else-if="selectType === 'multi'" class="multiSelect">
  <el-checkbox :indeterminate="isIndeterminate" v-model="selectAll" @change="handleSelectAll"></el-checkbox>
  <el-select ref="mutiSelect" :disabled="disabled" :clearable="clearable" :class="selectClass" filterable multiple collapse-tags @change="setValue" v-model="selectModel" :placeholder="placeholder" :size="size" value-key="key">
    <el-option class="option-div" v-for="(item, index) in dataList" :key="index" :label="labelType === 'value' ? item : index + ' - ' + item" :value="valueType === 'value' ? index : {'key': index, 'value': item}"></el-option>
  </el-select>
</div>
</template>

<script>
export default {
  name: "qunji-select",
  props: {
    type: {
      type: String
    },
    placeholder: {
      type: String
    },
    selectDict: {
      type: String
    },
    //v-model
    value: {
      type: [String, Number, Array, Object]
    },
    defaultValue: {
      type: String
    },
    selectData: {
      type: [Object, Array]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    selectClass: {
      type: String
    },
    labelType: {
      type: String,
      default: "value"
    },
    valueType: {
      type: String,
      default: "value"
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      selectType: "",
      selectModel: "",
      selectAll: false,
      selectAllModel: [],
      isIndeterminate: false,
      dataList: this.selectData
    };
  },
  created() {
    if (this.isEmpty(this.type)) {
      this.selectType = "select";
      this.selectModel = this.defaultValue;
    } else {
      this.selectType = "multi";
    }

    if (this.selectData) {
      this.dataList = this.selectData;
      this.initValue();
    } else if (this.isNotEmpty(this.selectDict)) {
      this.initData(this.selectDict);
    }
  },
  mounted() {
    if (this.isNotEmpty(this.selectModel)) {
      this.setValue(this.selectModel);
    }
  },
  watch: {
    defaultValue() {
      this.selectModel = this.defaultValue;
      if (this.isNotEmpty(this.selectModel)) {
        this.setValue(this.selectModel);
      }
    },
    selectData(val, oldValue) {
      if (val === this.dataList) return;
      this.dataList = val;
      if (this.selectType === 'select') {
        this.selectModel = '';
      }else{
        this.selectModel = [];
      }
      this.getSelectAllValue();
    },
    value(val, oldValue) {
      if (!val || val === this.selectModel) return;
      this.selectModel = val;
      this.setValue(val);
    },
    deep: true
  },
  methods: {
    initData(selectDict) {
      this.queryPubParaDescList(selectDict).then(response => {
        if (this.isNotEmpty(response.data)) {
          let dataList = {};
          response.data.forEach(item => {
            dataList[item.key] = item.value;
          });
          this.dataList = dataList;
        }
        this.initValue();
      });
    },
    initValue() {
      this.getSelectAllValue();
      if (this.isEmpty(this.type)) {
        if (this.isNotEmpty(this.value) || this.isNotEmpty(this.defaultValue)) {
          this.selectModel = this.value || this.defaultValue;
        }
      } else if (this.selectType == "multi") {
        if (this.isNotEmpty(this.value)) {
          if (typeof this.value === "string" && this.value.length > 0) {
            //判断最后一位是否是','，再进行切割
            if (this.value.charAt(this.value.length - 1) == ",") {
              this.selectModel = this.value
                .substring(0, this.value.length - 1)
                .split(",");
            } else {
              this.selectModel = this.value.split(",");
            }
          } else {
            this.selectModel = this.value;
          }
        } else if (this.isNotEmpty(this.defaultValue)) {
          this.selectModel = this.defaultValue.split(",");
        } else {
          this.selectModel = [];
        }
      }
    },
    setValue(val) {
      if (this.selectType === "multi") {
        let selectCount = val.length;
        if (this.selectAllModel.length === 0) {
          this.selectAll = false;
        } else {
          this.selectAll = selectCount === this.selectAllModel.length;
        }
        this.isIndeterminate =
          selectCount > 0 && selectCount < this.selectAllModel.length;
      }
      this.$emit("input", val);
      this.$emit("change", val);
    },
    handleSelectAll(val) {
      this.selectModel = val ? this.selectAllModel : [];
      this.isIndeterminate = false;
      this.setValue(this.selectModel);
    },
    getSelectAllValue() {
      let selectAllModel = [];
      for (var key in this.dataList) {
        if (this.valueType === "value") {
          selectAllModel.push(key);
        } else {
          selectAllModel.push({
            key: key,
            value: this.dataList[key]
          });
        }
      }
      this.selectAllModel = selectAllModel;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
.multiSelect {
  width: 180px;
  display: inline-block;
  .el-checkbox {
    position: absolute;
    margin-top: 0px;
    margin-left: 10px;
  }
  .el-select {
    .el-input__inner {
      padding-left: 40px;
    }
    .el-select__tags {
      margin-left: 18px;
    }
    .el-tag {
      margin-left: 20px;
    }
    .el-tag:nth-child(2) {
      margin-left: 1px;
      .el-select__tags-text {
        margin: 1px 0 2px 4px;
      }
    }
  }
}
</style>